import _ from "lodash"
import moment from "moment"
import settings from "settings"

export function totalMarketingFee(lot, sales) {
	let val
	try {
		if (!lot.addl) return false
		if (lot.addl && lot.addl["Marketing Fee Type"] == "Flat Fee") {
			val = lot.addl["Initial Marketing Fee"]
		} else {
			// percentage
			if (lot.lot_status == "Closed") {
				// find closing price
				let closing = _.find(sales, (r) => {
					if (lot.id == r.lot_id && r.closing_price) {
						return true
					}
				})
				if (closing) {
					val = closing.closing_price * (lot.addl["Marketing Fee %"] / 100)
					val = _.round(val, 2)
				} else val = 0
			} else {
				val = 0
			}
		}
		return val
	} catch (e) {
		console.log(e)
	}
}

export function calculateTrueUp(lot, close, onSale, adjusted) {
	// onSale is for true up projections where we're looking at an active contract and using price and estimated closing date
	// close is the closed sale
	// if adjusted is true then < 0 values are set to 0 and caps are implemented
	try {
		let type = _.get(lot, `addl[True Up Calculation Type]`)
		let truePercent = parseFloat(_.get(lot, `addl[True Up Percentage]`)) || 0
		let cap = parseFloat(_.get(lot, `addl[True Up Cap]`)) || null
		let min = parseFloat(_.get(lot, `addl[True Up Minimum]`)) || null
		let base = parseFloat(lot?.base_price) || 0
		let premium = parseFloat(lot?.premium) || 0
		// check for additional premiums in settings
		let check = _.get(settings, `localFields.lotPremiums`)
		if (check) {
			_.forEach(check, (r) => {
				let val = parseFloat(_.get(lot, `addl[${r}]`))
				if (val && typeof val == "number") premium += val
			})
		}
		let val
		if (onSale && close) {
			close.closing_price = close?.price
		}
		//? For interest, sometimes a lot is purchased directly at the beginning of a section, so there won't be a interest start date, but there would be a rate.  The calculation in that case should be $0 per Kathy @ Caldwell.
		if (type == "B") {
			if (close && close.closing_price && truePercent && base) {
				val = close.closing_price * (truePercent / 100) - base
			}
		} else if (type == "D") {
			if (close && close.closing_price && truePercent && base) {
				if (!premium) premium = 0
				val = close.closing_price * (truePercent / 100) - base - premium
			}
		} else if (type == "A") {
			//? This one and the next may have interest be 0.  The calculateInterest function returns an int of 0 so it's ok.
			let interest = calculateInterest(lot)
			if (close && close.closing_price && truePercent && base) {
				val = close.closing_price * (truePercent / 100) - base - interest
			}
		} else if (type == "C") {
			let interest = calculateInterest(lot)
			if (close && close.closing_price && truePercent && base) {
				val = close.closing_price * (truePercent / 100) - base - premium - interest
			}
		} else if (type === "F") {
			// No true up
			val = 0
		} else if (type === "E") {
			if (close && close.closing_price && base) {
				if (!premium) premium = 0
				// formula is Home sales price - premium = AHSP, then 20% of AHSP - base
				let ahsp = close.closing_price - premium
				val = ahsp * 0.2 - base
			}
		}

		if (adjusted && (!val || val < 0)) {
			//console.log(`No val or val less than $0`, val)
			val = 0
		} else if (adjusted && cap && val > cap) {
			val = cap
		} else if (adjusted && min && val < min) {
			val = min
		}
		if (val && val > 0) {
			val = _.round(val, 2)
		}
		return val
	} catch (e) {
		console.log(e)
	}
}

export function calculateInterest(lot) {
	let val
	let base = lot.base_price
	let rate = _.get(lot, `addl['Interest Rate']`)
	let start = _.get(lot, `addl[Interest Start Date]`)
	let escalation = _.get(lot, `addl['Escalation Fee']`)
	let td = lot.takedown_date
	if (escalation) {
		val = escalation
	} else if (lot?.lot?.fee_escalation) {
		val = lot.lot.fee_escalation
	} else if (rate && start && base && td) {
		let days = moment.unix(td).diff(moment.unix(start), "days")
		days = days / 365
		let cal = base * (rate / 100)
		val = days * cal
	} else {
		val = 0
	}

	return val
}
